import React from 'react'
import { NotFound } from 'secondstep-components'

const ExperiencePlayerTestOff = () => <NotFound />

export default ExperiencePlayerTestOff
